import { createAxiosInstance } from '@kc-console/core';

import { CONSOLE_USER_AGENT } from '../../constants';
import { env } from '../../utils';
import { getIamApiFetchers } from './getIamApiFetchers';

type Params = {
  token: string;
  iamEndpoint?: string;
};

const iamApiInstance = (params: Params) => {
  const { token, iamEndpoint = env.KC_IAM_SSR_ENDPOINT || '' } = params;
  const axiosInstance = createAxiosInstance({
    token,
    baseURL: iamEndpoint,
    overrideOnFulfilled: response => response,
    overrideAxiosRequestConfig: {
      withCredentials: true,
      headers: {
        'User-Agent': CONSOLE_USER_AGENT,
      },
    },
  });
  return getIamApiFetchers({ axiosInstance, token, iamEndpoint });
};

export default iamApiInstance;
